import React from 'react';
import { useEffect, useRef } from 'react';

import sanitizeHTML from '@utils/sanitizeHTML';

interface SafeHTMLRendererProps {
	html: string;
	className?: string;
}

/**
 * Safely renders HTML content by sanitizing it first and then rendering it
 * This is an alternative to dangerouslySetInnerHTML that provides better security
 */
export default function SafeHTMLRenderer({ html, className }: SafeHTMLRendererProps) {
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (containerRef.current && html) {
			const sanitizedHTML = sanitizeHTML(html);
			containerRef.current.innerHTML = sanitizedHTML;
		}
	}, [html]);

	return <div ref={containerRef} className={className} />;
}
